import { type PostsQuery } from '../model/contracts'

export function buildPostsQueryParams(query: PostsQuery): URLSearchParams {
  const params = new URLSearchParams()

  if (query.platform && (query.platform as string) !== 'all') {
    params.set('platform', query.platform)
  }
  if (query.search) params.set('search', query.search)
  if (query.startDate) params.set('startDate', query.startDate)
  if (query.endDate) params.set('endDate', query.endDate)
  if (query.author) params.set('author', query.author)
  if (typeof query.limit === 'number') params.set('limit', String(query.limit))
  if (typeof query.page === 'number') params.set('page', String(query.page))
  if (query.sentiment && query.sentiment.length > 0) {
    params.set('sentiment', query.sentiment.join(','))
  }
  if (query.keywords && query.keywords.length > 0) {
    params.set('keywords', query.keywords.join(','))
  }
  if (query.sort) params.set('sort', query.sort)

  return params
}
